export default __webpack_public_path__ + "static/media/total-with.9b390e91.png";